var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.897 6c.508-1.094.983-1.915 1.425-2.462H0V2.462h14.322c-.442-.547-.917-1.368-1.425-2.462h.86C14.79 1.248 15.87 2.17 17 2.77v.46c-1.13.582-2.211 1.505-3.243 2.77h-.86z"
  })));
}
export default SvgHorizontalArrow;